import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// Replaced axios with your instance
import axiosInstance from '../../api/axiosInstance';
import {
    FaEye, FaTrashAlt, FaTimes, FaSearch,
    FaAngleDoubleRight, FaCheckDouble, FaExchangeAlt,
    FaChevronLeft, FaChevronRight, FaChevronDown, FaChevronUp,
    FaPrint, FaUser, FaMapMarkerAlt, FaGraduationCap, FaBriefcase, FaListOl, FaBookReader,
    FaFileExcel
} from 'react-icons/fa';
import './ViewAdmissionForm.css';
import logo from '../../assets/sk-tt.jpg'; 

// API_BASE_URL is still needed for displaying images (<img> src)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// --- VIEW MODAL (DOCUMENT LAYOUT) ---
const ViewModal = ({ data, onClose }) => {
    // Effects for print styling body class
    useEffect(() => {
        if (data) {
            document.body.classList.add('printing-active');
        } else {
            document.body.classList.remove('printing-active');
        }
        return () => {
            document.body.classList.remove('printing-active');
        };
    }, [data]);

    if (!data) return null;

    const getFileUrl = (relativePath) => {
        if (!relativePath) return null;
        const cleanPath = relativePath.replace(/\\/g, '/');
        // Using API_BASE_URL here because <img src> needs the full string
        return `${API_BASE_URL}/${cleanPath}`;
    };
    
    const handlePrint = () => {
        window.print();
    };

    const EduRow = ({ label, eduData }) => {
        const d = eduData || {};
        return (
            <tr>
                <td className="view-sk-trainee-form-doc-fixed-col">{label}</td>
                <td><input type="text" value={d.total || ''} readOnly /></td>
                <td><input type="text" value={d.obtained || ''} readOnly /></td>
                <td><input type="text" value={d.percent || ''} readOnly /></td>
                <td><input type="text" value={d.div || ''} readOnly /></td>
                <td><input type="text" value={d.subj || ''} readOnly /></td>
                <td><input type="text" value={d.board || ''} readOnly /></td>
                <td><input type="text" value={d.cert || ''} readOnly /></td>
            </tr>
        );
    };

    return (
        <div className="view-sk-trainee-form-modal-overlay">
            <div className="view-sk-trainee-form-modal-content">
                
                {/* Modal Header (Not Printed) */}
                <div className="view-sk-trainee-form-modal-header view-sk-trainee-form-no-print">
                    <h3>Candidate Profile View</h3>
                    <div className="view-sk-trainee-form-modal-actions">
                         <button className="view-sk-trainee-form-btn-print" onClick={handlePrint} title="Print Form">
                            <FaPrint /> Print Form
                        </button>
                        <button className="view-sk-trainee-form-btn-close" onClick={onClose}><FaTimes /></button>
                    </div>
                </div>

                {/* Printable Area Wrapper */}
                <div className="view-sk-trainee-form-modal-body">
                    <div id="view-sk-trainee-form-printable-area" className="view-sk-trainee-form-doc-container">
                        
                        {/* --- HEADER --- */}
                        <div className="view-sk-trainee-form-doc-header">
                            <div className="view-sk-trainee-form-doc-header-flex">
                                <div className="view-sk-trainee-form-doc-logo">
                                    <img src={logo} alt="S.K. College Logo" />
                                </div>
                                <div className="view-sk-trainee-form-doc-titles">
                                    <h1 className="view-sk-trainee-form-doc-hindi-title">सुचेता कृपलानी शिक्षक प्रशिक्षण महाविद्यालय</h1>
                                    <p className="view-sk-trainee-form-doc-affiliation">जय नारायण व्यास विश्वविद्यालय, जोधपुर (JNVU), राजस्थान से सम्बद्ध (Affiliated) है।</p>
                                    <p className="view-sk-trainee-form-doc-address">पता :- ग्रा. पो. – मानकलाव, जोधपुर, 342305 राज.</p>
                                </div>
                            </div>
                            <div className="view-sk-trainee-form-doc-divider"></div>
                            <div className="view-sk-trainee-form-doc-main-title">
                                <h3>प्रशिक्षणार्थी आलेख – पत्र <span className="view-sk-trainee-form-doc-eng-sub">(Trainee Profile – Form)</span></h3>
                            </div>
                            <div className="view-sk-trainee-form-doc-session">
                                <span>सत्र 20</span>
                                <input type="text" value={data.sessionStart || ''} readOnly />
                                <span>- 20</span>
                                <input type="text" value={data.sessionEnd || ''} readOnly />
                            </div>
                        </div>

                        <div className="view-sk-trainee-form-doc-content">
                            
                            {/* --- 1. TRAINEE DETAILS (PAGE 1) --- */}
                            <div id="print-sec-trainee" className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaUser /> प्रशिक्षणार्थी विवरण (Trainee Details)</h3>
                                
                                <div className="view-sk-trainee-form-doc-profile-layout">
                                    {/* Photo */}
                                    <div className="view-sk-trainee-form-doc-photo-area">
                                        <div className="view-sk-trainee-form-doc-photo-box">
                                            {data.photo ? (
                                                <img src={getFileUrl(data.photo)} alt="Student" />
                                            ) : (
                                                <div className="view-sk-trainee-form-doc-photo-placeholder">
                                                    <span>No Photo</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Inputs */}
                                    <div className="view-sk-trainee-form-doc-inputs-area">
                                        <div className="view-sk-trainee-form-grid-2">
                                            <div className="view-sk-trainee-form-group">
                                                <label>प्रशिक्षणार्थी का नाम (अंग्रेजी में)</label>
                                                <input type="text" value={data.studentName || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>जन्म तिथि / DOB</label>
                                                <input type="text" value={data.dob ? new Date(data.dob).toISOString().split('T')[0] : ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>लिंग / Gender</label>
                                                <input type="text" value={data.gender || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>रक्त समूह / Blood Group</label>
                                                <input type="text" value={data.bloodGroup || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>पिता का नाम / Father's Name</label>
                                                <input type="text" value={data.fatherName || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>माता का नाम / Mother's Name</label>
                                                <input type="text" value={data.motherName || ''} readOnly />
                                            </div>
                                        </div>

                                        <div className="view-sk-trainee-form-grid-3 view-sk-trainee-form-mt-3">
                                            <div className="view-sk-trainee-form-group">
                                                <label>आधार क्रमांक / Aadhar No.</label>
                                                <input type="text" value={data.aadharNumber || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>धर्म / Religion</label>
                                                <input type="text" value={data.religion || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>जाति / Caste</label>
                                                <input type="text" value={data.caste || ''} readOnly />
                                            </div>
                                        </div>

                                        <div className="view-sk-trainee-form-grid-2 view-sk-trainee-form-mt-3">
                                            <div className="view-sk-trainee-form-group">
                                                <label>श्रेणी (Category)</label>
                                                <input type="text" value={data.category || ''} readOnly />
                                            </div>
                                            <div className="view-sk-trainee-form-group">
                                                <label>प्रमाण-पत्र संख्या / Certificate No.</label>
                                                <input type="text" value={data.categoryCertificate || ''} readOnly />
                                            </div>
                                        </div>

                                        {/* Special Reservation */}
                                        <div className="view-sk-trainee-form-doc-reservation view-sk-trainee-form-mt-3">
                                            <label className="view-sk-trainee-form-doc-sub-label">अतिरिक्त आरक्षण श्रेणी / Special Reservation</label>
                                            
                                            <div className="view-sk-trainee-form-doc-res-grid">
                                                {/* Card 1 */}
                                                <div className={`view-sk-trainee-form-doc-res-card ${data.isDisabled ? 'active' : ''}`}>
                                                    <div className="view-sk-trainee-form-doc-res-header">
                                                        <div className={`view-sk-trainee-form-chk ${data.isDisabled ? 'checked' : ''}`}></div>
                                                        <span>Disabled (विकलांग)</span>
                                                    </div>
                                                    <input type="text" value={data.disabledCert || ''} placeholder="Cert No." readOnly />
                                                </div>

                                                {/* Card 2 */}
                                                <div className={`view-sk-trainee-form-doc-res-card ${data.isExService ? 'active' : ''}`}>
                                                    <div className="view-sk-trainee-form-doc-res-header">
                                                        <div className={`view-sk-trainee-form-chk ${data.isExService ? 'checked' : ''}`}></div>
                                                        <span>Ex-Service (सैनिक)</span>
                                                    </div>
                                                    <input type="text" value={data.exServiceCert || ''} placeholder="Cert No." readOnly />
                                                </div>

                                                {/* Card 3 */}
                                                <div className={`view-sk-trainee-form-doc-res-card ${data.isWidow ? 'active' : ''}`}>
                                                    <div className="view-sk-trainee-form-doc-res-header">
                                                        <div className={`view-sk-trainee-form-chk ${data.isWidow ? 'checked' : ''}`}></div>
                                                        <span>Widow (विधवा)</span>
                                                    </div>
                                                    <input type="text" value={data.widowCert || ''} placeholder="Cert No." readOnly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* --- 2. CONTACT DETAILS (PAGE 1 - FORCE BREAK AFTER) --- */}
                            <div id="print-sec-contact" className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaMapMarkerAlt /> संपर्क जानकारी (Contact Details)</h3>
                                <div className="view-sk-trainee-form-grid-1">
                                    <div className="view-sk-trainee-form-group">
                                        <label>1. स्थायी पता / Permanent Address</label>
                                        <textarea value={data.permanentAddress || ''} rows="2" readOnly></textarea>
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>2. वर्तमान पता / Current Address</label>
                                        <textarea value={data.currentAddress || ''} rows="2" readOnly></textarea>
                                    </div>
                                </div>
                                <div className="view-sk-trainee-form-grid-2 view-sk-trainee-form-mt-3">
                                    <div className="view-sk-trainee-form-group">
                                        <label>3. मोबाइल नंबर / Mobile Number</label>
                                        <input type="text" value={data.mobile || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>4. ईमेल आईडी / Email ID</label>
                                        <input type="text" value={data.email || ''} readOnly />
                                    </div>
                                </div>
                            </div>

                            {/* --- 3. SERVICE DETAILS (STARTS PAGE 2) --- */}
                            <div id="print-sec-service" className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaBriefcase /> सेवा विवरण (Service Details)</h3>
                                <div className="view-sk-trainee-form-grid-3">
                                    <div className="view-sk-trainee-form-group">
                                        <label>पद / Designation</label>
                                        <input type="text" value={data.designation || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>विभाग / Department</label>
                                        <input type="text" value={data.department || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>पदस्थापना पता / Posting Address</label>
                                        <input type="text" value={data.postingAddress || ''} readOnly />
                                    </div>
                                </div>
                            </div>

                            {/* --- 4. COUNSELING DETAILS --- */}
                            <div className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaListOl /> काउंसलिंग विवरण (Counseling Details)</h3>
                                <div className="view-sk-trainee-form-grid-3">
                                    <div className="view-sk-trainee-form-group">
                                        <label>संकाय / Faculty</label>
                                        <input type="text" value={data.faculty || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>प्रवेश क्रम संख्या / Admission Serial</label>
                                        <input type="text" value={data.admissionSerial || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>श्रेणी / Category</label>
                                        <input type="text" value={data.counselingCategory || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>अनुक्रमांक (Roll No.)</label>
                                        <input type="text" value={data.rollNo || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>कुल प्राप्तांक / Total Marks</label>
                                        <input type="text" value={data.totalEntranceMarks || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>वरीयता क्रम / Merit Rank</label>
                                        <input type="text" value={data.meritRank || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>जिला / District</label>
                                        <input type="text" value={data.district || ''} readOnly />
                                    </div>
                                </div>
                            </div>

                            {/* --- 5. EDUCATIONAL QUALIFICATIONS --- */}
                            <div className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaGraduationCap /> शैक्षणिक योग्यता (Educational Qualifications)</h3>
                                <div className="view-sk-trainee-form-doc-table-wrapper">
                                    <table className="view-sk-trainee-form-doc-edu-table">
                                        <thead>
                                            <tr>
                                                <th>परीक्षा (Exam)</th>
                                                <th>कुल (Total)</th>
                                                <th>प्राप्तांक (Obt.)</th>
                                                <th>%</th>
                                                <th>Div</th>
                                                <th>विषय (Subj)</th>
                                                <th>बोर्ड (Board)</th>
                                                <th>Cert. No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <EduRow label="Secondary" eduData={data.eduHighSchool} />
                                            <EduRow label="Higher Sec" eduData={data.eduHigherSec} />
                                            <EduRow label="Graduation" eduData={data.eduGraduation} />
                                            <EduRow label="Post Grad" eduData={data.eduPostGrad} />
                                            <EduRow label="Others" eduData={data.eduOther} />
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* --- 6. SUBJECTS --- */}
                            <div className="view-sk-trainee-form-doc-section">
                                <h3 className="view-sk-trainee-form-doc-sec-title"><FaBookReader /> प्रशिक्षण हेतु चयनित विषय (Teaching Subjects)</h3>
                                <div className="view-sk-trainee-form-grid-2">
                                    <div className="view-sk-trainee-form-group">
                                        <label>Teaching Subject 1</label>
                                        <input type="text" value={data.trainingSub1 || ''} readOnly />
                                    </div>
                                    <div className="view-sk-trainee-form-group">
                                        <label>Teaching Subject 2</label>
                                        <input type="text" value={data.trainingSub2 || ''} readOnly />
                                    </div>
                                </div>
                            </div>

                            {/* Footer for Print Only */}
                            <div className="view-sk-trainee-form-doc-footer-print">
                                <div className="view-sk-trainee-form-doc-signature-box">
                                    Office Seal
                                </div>
                                <div className="view-sk-trainee-form-doc-signature-box">
                                    Student Signature
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- MAIN ADMIN PANEL ---
const AdminAdmissions = () => {
    const [admissions, setAdmissions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('All');
    const [viewingData, setViewingData] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // --- FETCH USING AXIOS INSTANCE ---
    const fetchAdmissions = async () => {
        try {
            // Updated to use axiosInstance
            const res = await axiosInstance.get('/api/admissions/all');
            setAdmissions(res.data);
        } catch (error) {
            console.error("Fetch error:", error);
            // Check for 401 before alerting
            if (error.response?.status !== 401) {
                Swal.fire('Error', 'Could not fetch data.', 'error');
            }
        }
    };

    useEffect(() => { fetchAdmissions(); }, []);

    const toggleRow = (id) => setExpandedRow(prev => (prev === id ? null : id));
    const formatDate = (d) => d ? new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '-';

    const filteredData = useMemo(() => {
        return admissions.filter(item => {
            if (statusFilter !== 'All' && item.status !== statusFilter) return false;
            const term = searchTerm.toLowerCase();
            return (
                item.studentName?.toLowerCase().includes(term) ||
                item.mobile?.includes(term) ||
                item.email?.toLowerCase().includes(term) ||
                item.faculty?.toLowerCase().includes(term)
            );
        });
    }, [admissions, searchTerm, statusFilter]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) setCurrentPage(newPage);
    };

    // --- UPDATE STATUS USING AXIOS INSTANCE ---
    const updateStatusAPI = async (id, status) => {
        try {
            const updateData = { status };
            if(status === 'Approved' || status === 'Rejected') {
                updateData.resolvedOn = new Date();
            }
            // Updated to use axiosInstance
            const res = await axiosInstance.put(`/api/admissions/status/${id}`, updateData);
            setAdmissions(prev => prev.map(item => item._id === id ? res.data : item));
            return true;
        } catch (error) {
            if (error.response?.status !== 401) {
                Swal.fire('Error', 'Action failed', 'error');
            }
            return false;
        }
    };

    const handleStartProcess = (id) => Swal.fire({ title: 'Start Processing?', icon: 'question', showCancelButton: true, confirmButtonText: 'Yes' }).then(r => { if(r.isConfirmed) updateStatusAPI(id, 'In Progress'); });
    const handleDecision = (id) => Swal.fire({ title: 'Decision', showDenyButton: true, showCancelButton: true, confirmButtonText: 'Approve', denyButtonText: 'Reject' }).then(r => { if(r.isConfirmed) updateStatusAPI(id, 'Approved'); else if(r.isDenied) updateStatusAPI(id, 'Rejected'); });
    const handleChangeStatus = (item) => { const newStatus = item.status === 'Approved' ? 'Rejected' : 'Approved'; Swal.fire({ title: `Change to ${newStatus}?`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes' }).then(r => { if(r.isConfirmed) updateStatusAPI(item._id, newStatus); }); };
    
    // --- DELETE USING AXIOS INSTANCE ---
    const handleDelete = (id) => Swal.fire({ title: 'Delete?', text: "Cannot be undone!", icon: 'warning', showCancelButton: true, confirmButtonColor: '#d33' }).then(async r => { 
        if (r.isConfirmed) { 
            try { 
                // Updated to use axiosInstance
                await axiosInstance.delete(`/api/admissions/delete/${id}`); 
                setAdmissions(prev => prev.filter(i => i._id !== id)); 
                Swal.fire('Deleted!', '', 'success'); 
            } catch (e) { 
                if (e.response?.status !== 401) {
                    Swal.fire('Error', 'Delete failed', 'error'); 
                }
            } 
        } 
    });

    // --- ADVANCED FULLY DESIGNED EXCEL EXPORT (EXCELJS) ---
    const handleExport = async () => {
        if (filteredData.length === 0) {
            return Swal.fire('Notice', 'No data to export.', 'info');
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Admissions List');

        // 1. Title Row Block
        worksheet.mergeCells('A1:R1');
        worksheet.getCell('A1').value = 'SUCHETA KRIPLANI TEACHER TRAINING COLLEGE';
        worksheet.getCell('A1').font = { name: 'Arial', size: 16, bold: true, color: { argb: 'FF1E3A8A' } }; // Royal Blue Brand Color
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };

        // 2. Subtitle Row Block
        worksheet.mergeCells('A2:R2');
        worksheet.getCell('A2').value = 'Trainee Profiles & Admission Directory (प्रशिक्षणार्थी प्रवेश विवरण तालिका)';
        worksheet.getCell('A2').font = { name: 'Arial', size: 12, bold: true, color: { argb: 'FF2C3E50' } };
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

        // 3. Filter Information Summary Block
        worksheet.mergeCells('A3:R3');
        worksheet.getCell('A3').value = `Search Query: ${searchTerm || 'All'}  |  Status Filter: ${statusFilter || 'All'}  |  Total Count: ${filteredData.length} records`;
        worksheet.getCell('A3').font = { name: 'Arial', size: 10, italic: true, color: { argb: 'FF64748B' } };
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.addRow([]); // Empty row for visual spacing

        // 4. Tabular Headers
        const headers = [
            'S.No', 'Session', 'Student Name', "Father's Name", "Mother's Name", 'DOB', 'Gender', 
            'Category', 'Aadhar No.', 'Mobile No.', 'Email ID', 'Faculty (Class)', 'Entrance Marks', 
            'Merit Rank', 'Subject 1', 'Subject 2', 'Status', 'Submitted On'
        ];

        const headerRow = worksheet.addRow(headers);
        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E3A8A' } }; // Royal Blue Header Fill
            cell.font = { color: { argb: 'FFFFFFFF' }, bold: true, name: 'Arial', size: 10 };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = { 
                top: { style: 'thin' }, 
                left: { style: 'thin' }, 
                bottom: { style: 'thin' }, 
                right: { style: 'thin' } 
            };
        });

        // 5. Data Rows Writing and Cell Formatting
        filteredData.forEach((item, i) => {
            const formattedDob = item.dob ? new Date(item.dob).toLocaleDateString('en-IN') : '—';
            const sessionText = (item.sessionStart && item.sessionEnd) ? `20${item.sessionStart}-20${item.sessionEnd}` : '—';
            const formattedSubmit = item.submittedOn ? new Date(item.submittedOn).toLocaleDateString('en-IN') : '—';

            const row = worksheet.addRow([
                i + 1,
                sessionText,
                item.studentName,
                item.fatherName || '—',
                item.motherName || '—',
                formattedDob,
                item.gender || '—',
                item.category || '—',
                item.aadharNumber || '—',
                item.mobile || '—',
                item.email || '—',
                item.faculty || '—',
                item.totalEntranceMarks || '—',
                item.meritRank || '—',
                item.trainingSub1 || '—',
                item.trainingSub2 || '—',
                item.status,
                formattedSubmit
            ]);

            row.eachCell((cell, colIndex) => {
                cell.border = { 
                    top: { style: 'thin', color: { argb: 'FFE2E8F0' } }, 
                    left: { style: 'thin', color: { argb: 'FFE2E8F0' } }, 
                    bottom: { style: 'thin', color: { argb: 'FFE2E8F0' } }, 
                    right: { style: 'thin', color: { argb: 'FFE2E8F0' } } 
                };
                cell.font = { name: 'Arial', size: 9 };

                // Left align long text, center shorter strings & numbers
                if ([3, 4, 5, 11].includes(colIndex)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                }
            });

            // Status Cell dynamic colors (Column 17)
            const statusCell = row.getCell(17);
            let statusColor = 'FF1E2A78'; // Default Royal Blue color code
            if (item.status === 'Approved') {
                statusColor = 'FF16A34A'; // Green
            } else if (item.status === 'Rejected') {
                statusColor = 'FFDC2626'; // Red
            } else if (item.status === 'In Progress') {
                statusColor = 'FFEA580C'; // Orange
            }
            statusCell.font = { bold: true, name: 'Arial', size: 9, color: { argb: statusColor } };
        });

        // 6. Define Custom Columns Widths to prevent content truncation
        worksheet.columns = [
            { width: 6 },   // S.No
            { width: 14 },  // Session
            { width: 22 },  // Student Name
            { width: 22 },  // Father's Name
            { width: 22 },  // Mother's Name
            { width: 13 },  // DOB
            { width: 10 },  // Gender
            { width: 12 },  // Category
            { width: 16 },  // Aadhar No
            { width: 14 },  // Mobile No
            { width: 26 },  // Email ID
            { width: 16 },  // Faculty
            { width: 14 },  // Entrance Marks
            { width: 12 },  // Merit Rank
            { width: 18 },  // Subject 1
            { width: 18 },  // Subject 2
            { width: 14 },  // Status
            { width: 14 }   // Submitted On
        ];

        // 7. Generate Excel Buffer & Save File
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'SK_TT_Admissions_List.xlsx');
    };

    return (
        <div className="view-sk-trainee-form-admin-wrapper">
            <div className="view-sk-trainee-form-admin-container">
                <ViewModal data={viewingData} onClose={() => setViewingData(null)} />
                
                <h1 className="view-sk-trainee-form-admin-heading">Teacher Training Admissions</h1>
                
                <div className="view-sk-trainee-form-admin-controls">
                    <div className="view-sk-trainee-form-admin-controls-row">
                        <div className="view-sk-trainee-form-admin-search">
                            <FaSearch />
                            <input type="text" placeholder="Search name, mobile, faculty..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                        <div className="view-sk-trainee-form-admin-actions-right">
                            <div className="view-sk-trainee-form-admin-pagination-size">
                                <span>Show</span>
                                <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                                    <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
                                </select>
                                <span>entries</span>
                            </div>
                            <select className="view-sk-trainee-form-admin-status-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                                <option value="All">All Status</option><option value="Open">Open</option><option value="In Progress">In Progress</option><option value="Approved">Approved</option><option value="Rejected">Rejected</option>
                            </select>
                            <button className="view-sk-trainee-form-admin-btn-export" onClick={handleExport}><FaFileExcel /> Export All</button>
                        </div>
                    </div>
                </div>

                <div className="view-sk-trainee-form-admin-table-card">
                    <div className="view-sk-trainee-form-admin-table-scroll">
                        <table className="view-sk-trainee-form-admin-table">
                            <thead>
                                <tr>
                                    <th className="view-sk-col-sno">S.No</th><th className="view-sk-col-name">Student Name</th><th className="view-sk-col-contact">Contact Number</th>
                                    <th className="view-sk-col-email">Email ID</th><th className="view-sk-col-class">Faculty</th><th className="view-sk-col-submit">Submitted On</th>
                                    <th className="view-sk-col-status">Status</th><th className="view-sk-col-resolve">Resolved On</th><th className="view-sk-col-action">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (currentItems.map((item, index) => (
                                    <React.Fragment key={item._id}>
                                        <tr className={item.status === 'Open' ? 'view-sk-trainee-form-row-new' : ''}>
                                            <td className="view-sk-col-sno">{indexOfFirstItem + index + 1}</td>
                                            <td className="view-sk-col-name view-sk-trainee-form-cell-name">
                                                <span>{item.studentName}</span>
                                                <button className="view-sk-trainee-form-btn-toggle" onClick={() => toggleRow(item._id)}>
                                                    {expandedRow === item._id ? <FaChevronUp /> : <FaChevronDown />}
                                                </button>
                                            </td>
                                            <td className="view-sk-col-contact">{item.mobile}</td>
                                            <td className="view-sk-col-email">{item.email}</td>
                                            <td className="view-sk-col-class">{item.faculty || 'N/A'}</td>
                                            <td className="view-sk-col-submit">{formatDate(item.submittedOn)}</td>
                                            <td className="view-sk-col-status"><span className={`view-sk-trainee-form-badge ${item.status.toLowerCase().replace(' ', '-')}`}>{item.status}</span></td>
                                            <td className="view-sk-col-resolve">{item.resolvedOn ? formatDate(item.resolvedOn) : '-'}</td>
                                            <td className="view-sk-col-action">
                                                <div className="view-sk-trainee-form-action-group">
                                                    <button className="view-sk-trainee-form-btn-action view" onClick={() => setViewingData(item)} title="View Details"><FaEye /></button>
                                                    {item.status === 'Open' && <button className="view-sk-trainee-form-btn-action process" onClick={() => handleStartProcess(item._id)}><FaAngleDoubleRight /></button>}
                                                    {item.status === 'In Progress' && <button className="view-sk-trainee-form-btn-action decision" onClick={() => handleDecision(item._id)}><FaCheckDouble /></button>}
                                                    {(item.status === 'Approved' || item.status === 'Rejected') && (<>
                                                        <button className="view-sk-trainee-form-btn-action change" onClick={() => handleChangeStatus(item)}><FaExchangeAlt /></button>
                                                        <button className="view-sk-trainee-form-btn-action delete" onClick={() => handleDelete(item._id)}><FaTrashAlt /></button>
                                                    </>)}
                                                </div>
                                            </td>
                                        </tr>
                                        {expandedRow === item._id && (
                                            <tr className="view-sk-trainee-form-row-expanded">
                                                <td colSpan="9">
                                                    <div className="view-sk-trainee-form-expanded-grid">
                                                        <div className="view-sk-exp-item view-sk-exp-contact"><strong>Contact Number:</strong> <span>{item.mobile}</span></div>
                                                        <div className="view-sk-exp-item view-sk-exp-email"><strong>Email:</strong> <span>{item.email}</span></div>
                                                        <div className="view-sk-exp-item view-sk-exp-class"><strong>Faculty:</strong> <span>{item.faculty}</span></div>
                                                        <div className="view-sk-exp-item view-sk-exp-status"><strong>Status:</strong> <span className={`view-sk-trainee-form-badge ${item.status.toLowerCase().replace(' ', '-')}`}>{item.status}</span></div>
                                                        <div className="view-sk-exp-item view-sk-exp-submit"><strong>Submitted On:</strong> <span>{formatDate(item.submittedOn)}</span></div>
                                                        <div className="view-sk-exp-item view-sk-exp-resolve"><strong>Resolved On:</strong> <span>{item.resolvedOn ? formatDate(item.resolvedOn) : '-'}</span></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))) : (
                                    <tr><td colSpan="9" style={{textAlign: 'center', padding: '2rem'}}>No records found</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="view-sk-trainee-form-admin-footer">
                    <div className="view-sk-trainee-form-page-info">
                        Showing {currentItems.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
                    </div>
                    <div className="view-sk-trainee-form-page-nav">
                        <button className="view-sk-trainee-form-btn-page" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>
                            <FaChevronLeft /> Previous
                        </button>
                        <span className="view-sk-trainee-form-page-count">Page {currentPage} of {totalPages || 1}</span>
                        <button className="view-sk-trainee-form-btn-page" disabled={currentPage === totalPages || totalPages === 0} onClick={() => handlePageChange(currentPage + 1)}>
                            Next <FaChevronRight />
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminAdmissions;